import { paramsString, promisedRequest } from './helpers.js'

import { parseLinkHeaderPagination } from 'src/services/entity_normalizer/entity_normalizer.service.js'

// Hashtags: look one up, follow or unfollow it, list the followed ones.

const TAG_URL = (name) => `/api/v1/tags/${encodeURIComponent(name)}`
const FOLLOWED_TAGS_URL = '/api/v1/followed_tags'

export const followTag = ({ credentials, name }) =>
  promisedRequest({
    url: `${TAG_URL(name)}/follow`,
    method: 'POST',
    credentials,
  })

export const unfollowTag = ({ credentials, name }) =>
  promisedRequest({
    url: `${TAG_URL(name)}/unfollow`,
    method: 'POST',
    credentials,
  })

// all of them, page after page, as the Link headers lead
export const fetchFollowedTags = async ({ credentials }) => {
  const all = []
  let maxId
  for (let page = 0; page < 25; page++) {
    const { data, response } = await promisedRequest({
      url: `${FOLLOWED_TAGS_URL}${paramsString({ maxId, limit: 40 })}`,
      credentials,
    })
    all.push(...data)
    maxId = parseLinkHeaderPagination(response.headers.get('Link'), {
      flakeId: true,
    })?.maxId
    if (!maxId || data.length === 0) break
  }
  return { data: all }
}
